module.exports = __webpack_public_path__ + "assets/img/master.3820ddf2.png";